// extracted by mini-css-extract-plugin
module.exports = {"container":"ValueFilter_container__2FM4z","rangeSlider":"ValueFilter_rangeSlider__2yhWk","inputs":"ValueFilter_inputs__1YaZO"};